import { useAppSelector } from '../utilities/hooks';
import { IDevelopmentState } from '../slices/developmentSlice';
import { RootState } from '../store';

export const useSelectorDevelopment = () => {
    return useAppSelector<IDevelopmentState>((state: RootState) => state.development);
};
